module.exports = __webpack_public_path__ + "img/tip-right.6e365be8.png";